import { render, staticRenderFns } from "./SystemParamsHome.vue?vue&type=template&id=70af1b2e&"
import script from "./SystemParamsHome.vue?vue&type=script&lang=ts&"
export * from "./SystemParamsHome.vue?vue&type=script&lang=ts&"
import style0 from "./SystemParams.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports